// removed by extract-text-webpack-plugin
module.exports = {"binary_dialog_close_button":"_3o01IcD4bgCojMUE8xECdb","binary_dialog_button":"_29v81X7f3IxshDWxuCyGPE","binary_dialog_action_button":"_1kEL9Mcj0pN_QuTI2SL7Gh"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryDialog/BinaryDialog.scss
// module id = 2140
// module chunks = 1